<style scoped>
	.plan-card .button[disabled]:hover,
	.plan-card .button.disabled:hover {
		cursor: not-allowed;
	}
	.plan-cards {
		/* min-height: 389px; */
	}
	.plan-card {
		cursor: pointer;
		box-sizing: border-box;
		border-width: 2px;
		width: calc(25% - .75em);
	}

	.plan-card p {
		margin-bottom: 0;
	}
	.dark .plan-card {
		border-color: #333;
	}
	.dark .plan-card i {
		color: #333;
	}
	.plan-card.hidden + .plan-card,
	label[style*='display: none'] + .plan-card {
		margin-left: 0;
	}
	.plan-card.strikethrough {
		cursor: not-allowed;
	}
	.plan-card.strikethrough i {
		display: none;
	}
	.plan-card.single {
		width: 100%;
	}
	.plan-card > header > h1 {
		margin-top: 0;
	}
	.plan-card > header {
		margin-bottom: 1.5em;
	}
	.plan-card i {
		font-size: 1.2em;
		color: #ddd;
	}
	.plan-card.review-change i {
		display: none;
	}
	.plan-card.plan-card-primary {
		border-width: 2px;
	}
	.plan-card.selected {
		border-color: #2E88D6;
	}

	.plan-card.selected i {
		color: #2E88D6;
	}
	.plan-card > h2 {
		margin-top: 0;
	}

	.plan-card.selected i {
		display: block;
	}
	.plan-features li i:not(.success):not(.error),
	.plan-card.selected i {
		color: #2E88D6;
	}
	@media only screen and (max-width : 1120px) {
		.plan-cards {
			width: 100%;
			box-sizing: border-box;
			flex-wrap: wrap;
		}

		.plan-card {
		    box-sizing: border-box;
		}
	}

	@media (min-width : 640px) and (max-width : 1120px) {
		.plan-card:not(.review-change) {
			min-width: calc(50% - .5rem);
			max-width: calc(50% - .5rem);
		    box-sizing: border-box;
			margin-left: 0;
		}

		.plan-card:nth-child(even) {
			margin-left: 1rem;
		}

		.plan-card:nth-child(odd) {
			margin-left: 0;
		}

		.plan-card:nth-child(n+3) {
			margin-top: 1rem;
		}
	}

	@media only screen and (max-width: 600px) {
		.plan-card p {
			text-align: center;
		}
	}

	@media only screen and (max-width : 639px) {
		.row.separated .flexible.cost-summary {
			min-width: 100%;
			margin-left: 0 !important;
		}
		.row.separated-extra > * + .plan-comparison {
			margin-left: 0;
		}

		.plan-cards {
			flex-direction: column;
		}

		.plan-card {
			width: 100%;
		}

		.plan-card + .plan-card {
			margin-top: 1rem;
			margin-left: 0;
		}
	}

</style>

<template>
	<div v-if="loading">><i class="fas fa-spinner fa-spin"></i></div>
	<div v-else-if="current.extensionOptions.length <= 0" class="row centering">
		<!-- TODO: Make this a yellow banner -->
		<div class="notice warning">
			<p>There are no extension options for this subscription. If you believe this is a mistake, then please <a href="mailto:scope@support.tekcloud.com?subject=Error%20Extending%20License">let us know</a>.</p>
		</div>
	</div>
	<div v-else class="row plan-cards" role="radiogroup">
	<label v-for="(option, index) in current.extensionOptions" :key="index" class="plan-card extension" :class="{'selected': selectedExtension && selectedExtension.extensionLength === option.extensionLength}">
		<header class="row baseline separated">
			<h3 class="plan-title flexible">{{ option.extensionLength }}</h3>
			<i class="fas fa-check-circle"></i>
		</header>
		<p class="gray-6">{{ option.totalPrice | currency(true) }}</p>
		<input name="extensions" :value="selectedExtension" @change="setSelectedExtension(index)" hidden type="radio">
	</label>
</div>
</template>

<script>
import currency from '../filters/currency';

export default {
	props: {
		current: Object
	}
	,
	filters: {
		currency,
	},
	data() {
		return {
			loading: false,
			selectedExtension: null
		};
	},
	methods: {
		setSelectedExtension(index) {
			this.selectedExtension = this.current.extensionOptions[index];
			this.$emit('extension', this.selectedExtension);
		},
	}
};

</script>



// WEBPACK FOOTER //
// ./src/components/SelfServiceMaintenanceOptions.vue